import { createRouter, lazyRouteComponent } from "@tanstack/react-router";
import { queryClient } from "@/lib/query";
import { RoutePending } from "@/routing/ui/RoutePending";
import { routeTree } from "./routeTree";

const NotFound = lazyRouteComponent(() => import("@/pages/public/NotFound/Page"));

export const router = createRouter({
  routeTree,
  context: {
    queryClient,
  },
  defaultNotFoundComponent: NotFound,
  defaultPendingComponent: RoutePending,
  scrollRestoration: true,
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
